const currentView = localStorage.getItem('currentView')
const isExpanded = localStorage.getItem('isExpanded')

const initialState = {
    projectListFilterView: currentView || 'TileView',
    projectListFilterOptionsExpanded: isExpanded === 'true' ? isExpanded === 'true' : false,
    projectListFilters: null,
    automaticProjectListFilters: null,
    floorPlanListFilters: null,
    projectSort: JSON.stringify({'name': 'ASC', 'date': null})
};

export default function FilterViewReducer(state = initialState, action) {
    switch (action.type) {
        case "TOGGLE_PROJECT_LIST_FILTER_VIEW": {
            return {
                ...state,
                projectListFilterView: action.projectListFilterView
            };
        }

        case "TOGGLE_PROJECT_LIST_FILTER_OPTIONS_EXPANDED": {
            return {
                ...state,
                projectListFilterOptionsExpanded: action.projectListFilterOptionsExpanded
            };
        }
        
        case "SET_PROJECT_LIST_FILTERS": {
            return {
                ...state,
                projectListFilters: action.projectListFilters
            };
        }
        
        case "SET_AUTOMATIC_PROJECT_LIST_FILTERS": {
            return {
                ...state,
                automaticProjectListFilters: action.automaticProjectListFilters
            };
        }
        
        case "SET_FLOOR_PLAN_LIST_FILTERS": {
            return {
                ...state,
                floorPlanListFilters: action.floorPlanListFilters
            };
        }
        
        case "SET_PROJECT_SORT": {
            return {
                ...state,
                projectSort: action.projectSort
            };
        }

        default: {
            return state;
        }
    }
}